import { ApplicationConfigurationOptions } from '@waldur/core/types';

export const ENV: ApplicationConfigurationOptions = {
  apiEndpoint: 'http://localhost:8080/',
  pageSize: 10,
  buildId: 'latest',
  accountingMode: 'accounting',
  roles: [],
  excludedAttachmentTypes: [],
  enforceLatinName: true,
  authStorage: 'localStorage',
};
